// StatusSelect.jsx
// Client: vmfive
// Version: 1.0.0
// Inline status switcher — pill-shaped select that changes color by value

import React from 'react';
import './StatusSelect.css';

const STATUS_CONFIG = {
  draft: 'status-select--draft',
  active: 'status-select--active',
  paused: 'status-select--paused',
  archived: 'status-select--archived',
};

export default function StatusSelect({
  value,
  options = [],
  onChange,
  disabled = false,
  className = '',
}) {
  const statusClass = STATUS_CONFIG[value?.toLowerCase()] || '';

  return (
    <select
      className={`status-select ${statusClass} ${className}`}
      value={value}
      onChange={onChange}
      disabled={disabled}
      onClick={(e) => e.stopPropagation()}
    >
      {options.map((opt) => {
        const optValue = typeof opt === 'string' ? opt : opt.value;
        const optLabel = typeof opt === 'string' ? opt : opt.label;
        return (
          <option key={optValue} value={optValue}>
            {optLabel}
          </option>
        );
      })}
    </select>
  );
}
